// Classifies a redeemed share-target payload (see server/index.js
// POST /api/tp/share-target) into which existing extraction pipeline
// ShareInboxScreen should run: the image scanner (utils/scanDetails.js
// callers), the Instagram extractor (/api/tp/ig/extract), or the generic
// link extractor (/api/tp/link/extract).
//
// Android's share sheet doesn't reliably put a shared link in the Web Share
// Target `url` param — many apps share a plain-text intent with the link
// embedded inside the text body, which Chrome maps to `text`, not `url`.
// So a link has to be looked for in both fields, not just `url`.
const IG_RE = /instagram\.com/i;
const URL_IN_TEXT_RE = /https?:\/\/\S+/;
// Web Share Target's `url` param is attacker-controlled (any app can put
// anything in it) and, unlike the text-extracted fallback below, wasn't
// being scheme-checked — a share intent with url: "javascript:..." would
// flow straight into an idea's sourceUrl and get rendered as a clickable
// <a href> elsewhere (panels.js). Require http(s) here too so a non-URL or
// dangerous-scheme value never gets treated as a link at all.
const SAFE_URL_RE = /^https?:\/\//i;

export function sharedLinkFrom({ url, text } = {}) {
  const direct = (url || '').trim();
  if (direct && SAFE_URL_RE.test(direct)) return direct;
  const match = (text || '').match(URL_IN_TEXT_RE);
  return match ? match[0] : '';
}

export function classifySharePayload(payload = {}) {
  if (payload.hasImage) return 'image';
  const link = sharedLinkFrom(payload);
  if (!link) return 'none';
  return IG_RE.test(link) ? 'instagram' : 'link';
}
